import {AppResourceCollection} from '@milestoneslabs/milestones-js-engine';

export default {
    properties: new AppResourceCollection('Property'),
};
